/**
 * Represents the type of a space.
 */
export var SpaceType;
(function (SpaceType) {
    /**
     * Personal space.
     */
    SpaceType["Personal"] = "self";
    /**
     * Public space.
     */
    SpaceType["Public"] = "public";
    /**
     * Shared space.
     */
    SpaceType["Shared"] = "shared";
    // /**
    //  * All spaces.
    //  */
    SpaceType["All"] = "all";
    /**
     * Undefined space type.
     */
    SpaceType["Undefined"] = "undefined";
})(SpaceType || (SpaceType = {}));
/**
 * Represents the sort type of spaces.
 */
export var SpaceSortType;
(function (SpaceSortType) {
    /**
     * 创建时间从旧到新
     */
    SpaceSortType["CreateTimeAsc"] = "CREATE_TIME_ASC";
    /**
     * 创建时间从新到旧
     */
    SpaceSortType["CreateTimeDesc"] = "CREATE_TIME_DESC";
    /**
    //  * 更新时间从旧到新
    //  */
    // UpdateTimeAsc = 'UPDATE_TIME_ASC',
    /**
     * 更新时间从新到旧
     */
    SpaceSortType["UpdateTimeDesc"] = "UPDATE_TIME_DESC";
    /**
     * 访问时间从新到旧
     */
    SpaceSortType["AccessTimeDesc"] = "ACCESS_TIME_DESC";
    /**
     * 名称排序
     */
    SpaceSortType["Name"] = "NAME";
})(SpaceSortType || (SpaceSortType = {}));
/**
 * 空间列表视图类型
 */
export var SpaceViewType;
(function (SpaceViewType) {
    /**
     * 卡片视图
     */
    SpaceViewType["GRID"] = "grid";
    /**
     * 表格视图
     */
    SpaceViewType["TABLE"] = "table";
})(SpaceViewType || (SpaceViewType = {}));
/**
 * 空间路由名称
 */
export var SpaceRouteName;
(function (SpaceRouteName) {
    SpaceRouteName["Personal"] = "personal-workspaces";
    SpaceRouteName["Shared"] = "shared-workspaces";
    SpaceRouteName["Public"] = "public-workspaces";
})(SpaceRouteName || (SpaceRouteName = {}));
export var ImportType;
(function (ImportType) {
    ImportType["AI_PATENT"] = "AI_IMPORT_PATENT";
    ImportType["Patent"] = "patent";
    ImportType["Sequence"] = "sequence";
})(ImportType || (ImportType = {}));
export var SpaceColumnField;
(function (SpaceColumnField) {
    //名称（不可取消）
    SpaceColumnField["SpaceName"] = "spaceName";
    //权限
    SpaceColumnField["UserRole"] = "userRole";
    //更新时间（不可取消）
    SpaceColumnField["UpdateTime"] = "updateTime";
    SpaceColumnField["LastVisitTime"] = "lastVisitTime";
    SpaceColumnField["SpaceType"] = "spaceType";
    //更新者
    SpaceColumnField["UpdatedUser"] = "updatedUser";
    //文件夹数量
    SpaceColumnField["FolderCount"] = "folderCount";
    //创建时间
    SpaceColumnField["CreateTime"] = "createTime";
    //创建者
    SpaceColumnField["Creator"] = "creator";
    //专利
    SpaceColumnField["PatentCount"] = "patentCount";
    //文献
    SpaceColumnField["PaperCount"] = "paperCount";
    //序列
    SpaceColumnField["BioCount"] = "bioCount";
    //药物
    SpaceColumnField["DrugCount"] = "drugCount";
    //临床
    SpaceColumnField["ClinicalCount"] = "clinicalCount";
    //临床结果
    SpaceColumnField["ClinicalResultCount"] = "clinicalTrialResultCount";
    //风险投资
    SpaceColumnField["InvestmentCount"] = "investmentCount";
    //市场报告
    SpaceColumnField["MarketCount"] = "marketCount";
    //企业兼并
    SpaceColumnField["MergerCount"] = "mergerCount";
    //更多操作
    SpaceColumnField["Actions"] = "actions";
})(SpaceColumnField || (SpaceColumnField = {}));
export var SpaceUserRole;
(function (SpaceUserRole) {
    SpaceUserRole["Editor"] = "edit";
    SpaceUserRole["Manage"] = "manage";
    SpaceUserRole["Read"] = "read";
    SpaceUserRole["Custom"] = "custom";
    /**
     * @deprecated
     */
    SpaceUserRole["Owner"] = "owner";
    /**
     * @deprecated
     */
    SpaceUserRole["Stranger"] = "stranger";
    /**
     * @deprecated
     */
    SpaceUserRole["Label"] = "label";
})(SpaceUserRole || (SpaceUserRole = {}));
export var CooperationType;
(function (CooperationType) {
    CooperationType["ACCOUNT"] = "ACCOUNT";
    CooperationType["GROUP"] = "GROUP";
})(CooperationType || (CooperationType = {}));
